// JavaScript Document
var tour;
var firstRun = true;


	
$(document).ready(function(){
		
	if($('#tourbus-section, #tourbus-section-first, #tourbus-section-second, #tourbus-section-third, #tourbus-section-result').length > 0) {
		if(!getCookie('hideTourbusTutorial')) {
			//INIT TUTORIAL
			tour = $.tourbus( '#tourbus-section, #tourbus-section-first, #tourbus-section-second, #tourbus-section-third, #tourbus-section-result', {
				// outputs a lot of stuff to the console
				debug: false,
				
				// auto start when initialized
				autoDepart: true,
				
				// the depart-point of the tour
				startAt: 0,
		
												
				// global leg defaults
				leg: {
					// override scroll position (0 for top of page, etc)
					scrollTo: null,
					// duration of scroll animation
					scrollSpeed: 150,
					// how much space to leave above the leg when scrolled to
					scrollContext: 100,
					
					// position of leg in relation to target
					// supports top/right/bottom/left
					orientation: 'left',
					
					// alignment of leg to target
					// supports:
					//   left/right/center for orientation of top/bottom
					//   top/bottom/center for orientation of left/right
					align: 'center',
					
					// width of leg
					width: 'auto',
					
					// z-index of the leg
					zindex: 9999,
					
					// space between leg and target
					margin: 30,
					
					// forcibly override top/left positioning of leg
					top: null,
					left: null,
					
					// location of arrow, if applicable
					// if you pass a string (like "50%") it will be used
					// verbatim, if you pass a number, it will be in pixels
					arrow: "48%"
				}
			});
		}
	}
	
});

function setHideTourbusTutorial() {
	var expires = new Date();
	expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
	document.cookie = "hideTourbusTutorial=1; expires=" + expires.toGMTString();
}
